import AdsServicesFactory from '../../ads/Services/factory.js'
import {SearchServicesFactory} from '../../search/Services/factory.js'
import {SearchValueObjectsFactory} from '../../search/ValueObjects/factory.js'
import {VehiclesMappersFactory} from '../../vehicles/Mappers/factory.js'
import {SeoErrorsFactory} from '../Errors/factory.js'
import {SeoRequestsFactory} from '../Requests/factory.js'
// factories
import SeoValueObjectsFactory from '../ValueObjects/factory.js'
// mappers
import {BreadcrumbListStructuredDataSeoMapper} from './BreadcrumbListStructuredDataSeoMapper.js'
import {FaqStructuredDataSeoMapper} from './FaqStructuredDataSeoMapper.js'
import {FromArticleDataToStructuredDataVOSeoMapper} from './FromArticleDataToStructuredDataVOSeoMapper.js'
import {FromDealerEntityToStructuredDataValueObjectMapper} from './FromDealerEntityToStructuredDataValueObjectMapper.js'
import {FromJsonToTagCloudSeoRequestSeoMapper} from './FromJsonToTagCloudSeoRequestSeoMapper.js'
import {FromListVOToTagcloudListVOSeoMapper} from './FromListVOToTagcloudListVOSeoMapper.js'
import {FromNewsDetailPageMetaInformationToSeoDataVOMapper} from './FromNewsDetailPageMetaInformationToSeoDataVOMapper.js'
import {FromRawsFaqsToFaqsListVOMapper} from './FromRawsFaqsToFaqsListVOMapper.js'
import FromSchemaDataToSchemaValueObjectMapper from './FromSchemaDataToSchemaValueObjectMapper.js'
import {FromTagCloudJsonResponseToTagCloudSeoValueObjectSeoMapper} from './FromTagCloudJsonResponseToTagCloudSeoValueObjectSeoMapper.js'
import {ProductStructuredDataSeoMapper} from './ProductStructuredDataSeoMapper.js'
import {PublishYourAdStructuredDataValueObjectSeoMapper} from './PublishYourAdStructuredDataValueObjectSeoMapper.js'
import {SeoAdsDetailMetaInformationMapper} from './SeoAdsDetailMetaInformationMapper.js'
import {SeoAdsListMetaInformationMapper} from './SeoAdsListMetaInformationMapper.js'
import {SeoAdsListSemanticAutomaticMetaConfigMapper} from './SeoAdsListSemanticAutomaticMetaConfigMapper.js'
import {SeoAdsListSemanticBusesMetaConfigMapper} from './SeoAdsListSemanticBusesMetaConfigMapper.js'
import {SeoAdsListSemanticCampervanMetaConfigMapper} from './SeoAdsListSemanticCampervanMetaConfigMapper.js'
import {SeoAdsListSemanticCarsWithoutLicenseMetaConfigMapper} from './SeoAdsListSemanticCarsWithoutLicenseMetaConfigMapper.js'
import {SeoAdsListSemanticCarTrailerMetaConfigMapper} from './SeoAdsListSemanticCarTrailerMetaConfigMapper.js'
import {SeoAdsListSemanticCheapVansMetaConfigMapper} from './SeoAdsListSemanticCheapVansMetaConfigMapper.js'
import {SeoAdsListSemanticClassicCompetitionConfigMapper} from './SeoAdsListSemanticClassicCompetitionConfigMapper.js'
import {SeoAdsListSemanticColorMetaConfigMapper} from './SeoAdsListSemanticColorMetaConfigMapper.js'
import {SeoAdsListSemanticElectricMetaConfigMapper} from './SeoAdsListSemanticElectricMetaConfigMapper.js'
import {SeoAdsListSemanticEnvironmentalLabelMetaConfigMapper} from './SeoAdsListSemanticEnvironmentalLabelMetaConfigMapper.js'
import {SeoAdsListSemanticFinancedMetaConfigMapper} from './SeoAdsListSemanticFinancedMetaConfigMapper.js'
import {SeoAdsListSemanticLifestyleMetaConfigMapper} from './SeoAdsListSemanticLifestyleMetaConfigMapper.js'
import {SeoAdsListSemanticMaxPriceMetaConfigMapper} from './SeoAdsListSemanticMaxPriceMetaConfigMapper.js'
import {SeoAdsListSemanticMetaConfigMapper} from './SeoAdsListSemanticMetaConfigMapper.js'
import {SeoAdsListSemanticPrivateSellerMetaConfigMapper} from './SeoAdsListSemanticPrivateSellerMetaConfigMapper.js'
import {SeoAdsListSemanticSevenSeatsMetaConfigMapper} from './SeoAdsListSemanticSevenSeatsMetaConfigMapper.js'
import {SeoAdsListSemanticTractorsMetaConfigMapper} from './seoAdsListSemanticTractorsMetaConfigMapper.js'
import {SeoAdsListSemanticTrucksMetaConfigMapper} from './SeoAdsListSemanticTrucksMetaConfigMapper.js'
import {SeoAdsListSemanticVansMetaConfigMapper} from './seoAdsListSemanticVansMetaConfigMapper.js'
import {SeoAdsListSemanticYearMetaConfigMapper} from './SeoAdsListSemanticYearMetaConfigMapper.js'
import {SeoAdsListSubscriptionMetaInformationMapper} from './SeoAdsListSubscriptionMetaInformationMapper.js'
import SeoDataMapper from './SeoDataMapper.js'
import {SeoDealersListMetaInformationMapper} from './SeoDealersListMetaInformationMapper.js'
import {SeoEditMyAdMetaInformationMapper} from './SeoEditMyAdMetaInformationMapper.js'
import {SeoHomeMetaInformationMapper} from './SeoHomeMetaInformationMapper.js'
import {SeoInstantOfferStandaloneMetaInformationMapper} from './SeoInstantOfferStandaloneMetaInformationMapper.js'
import {SeoInsuranceMetaInformationMapper} from './SeoInsuranceMetaInformationMapper.js'
import {SeoLandingFinancingMetaInformationMapper} from './SeoLandingFinancingMetaInformationMapper.js'
import {SeoLandingFormalitiesMetaInformationMapper} from './SeoLandingFormalitiesMetaInformationMapper.js'
import {SeoLandingFormalitiesSecurityGuidelinesMetaInformationMapper} from './SeoLandingFormalitiesSecurityGuidelinesMetaInformationMapper.js'
import {SeoLandingInstantOfferMetaInformationMapper} from './SeoLandingInstantOfferMetaInformationMapper.js'
// web_seller_instant_offer_landing_test
import {SeoLandingInstantOfferTestMetaInformationMapper} from './SeoLandingInstantOfferTestMetaInformationMapper.js'
import {SeoLiteralMapper} from './SeoLiteralMapper.js'
import {SeoMakeMetaInformationMapper} from './SeoMakeMetaInformationMapper.js'
import {SeoMakesDistributorMetaInformationMapper} from './SeoMakesDistributorMetaInformationMapper.js'
import {SeoMetaInformationMapper} from './SeoMetaInformationMapper.js'
import {SeoModelDetailMetaInformationMapper} from './SeoModelDetailMetaInformationMapper.js'
import {SeoModelSizesMetaInformationMapper} from './SeoModelSizesMetaInformationMapper.js'
import {SeoNewsListMetaInformationMapper} from './SeoNewsListMetaInformationMapper.js'
import {SeoProfessionalStockMetaInformationMapper} from './SeoProfessionalStockMetaInformationMapper.js'
import {SeoPublishMyAdCategoryMetaInformationMapper} from './SeoPublishMyAdCategoryMetaInformationMapper.js'
import {SeoPublishMyAdMetaInformationMapper} from './SeoPublishMyAdMetaInformationMapper.js'
import {SeoPublishYourAdMetaInformationMapper} from './SeoPublishYourAdMetaInformationMapper.js'
import {SeoPublishYourAdWithPlateMetaInformationMapper} from './SeoPublishYourAdWithPlateMetaInformationMapper.js'
import {SeoStaticMetaInformationMapper} from './SeoStaticMetaInformationMapper.js'
import {SeoTechnicalDetailsMetaInformationMapper} from './SeoTechnicalDetailsMetaInformationMapper.js'
import {SeoTechnicalDetailsSearchMetaInformationMapper} from './SeoTechnicalDetailsSearchMetaInformationMapper.js'
import {SeoVehicleAppraiserMetaInformationMapper} from './SeoVehicleAppraiserMetaInformationMapper.js'
import {VehicleStructuredDataSeoMapper} from './VehicleStructuredDataSeoMapper.js'
import {VehicleTypeStructuredDataSeoMapper} from './VehicleTypeStructuredDataSeoMapper.js'
import {WebPageStructuredDataSeoMapper} from './WebPageStructuredDataSeoMapper.js'

export default class SeoMappersFactory {
  static breadcrumbListStructuredDataSeoMapper = ({config}) =>
    new BreadcrumbListStructuredDataSeoMapper({
      config,
      structuredDataValueObjectFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static faqStructuredDataSeoMapper = ({config}) =>
    new FaqStructuredDataSeoMapper({
      config,
      structuredDataValueObjectFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static fromDealerEntityToStructuredDataValueObjectMapper = ({config}) =>
    new FromDealerEntityToStructuredDataValueObjectMapper({
      config,
      structuredDataValueObjectFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static seoDataMapper = ({config} = {}) =>
    new SeoDataMapper({
      mapper: SeoMappersFactory.fromSchemaDataToSchemaValueObjectMapper({
        config
      }),
      config
    })

  static fromListVOToTagcloudListVOSeoMapper = ({config} = {}) =>
    new FromListVOToTagcloudListVOSeoMapper({
      config,
      tagcloudListValueObjectFactory: SeoValueObjectsFactory.tagcloudListValueObject,
      tagcloudSeoValueObjectFactory: SeoValueObjectsFactory.tagcloudSeoValueObject({config}),
      tagSeoValueObjectFactory: SeoValueObjectsFactory.tagSeoValueObject
    })

  static fromRawsFaqsToFaqsListVOMapper = ({config} = {}) =>
    new FromRawsFaqsToFaqsListVOMapper({
      config,
      faqsInfoValueObjectFactory: SeoValueObjectsFactory.faqsInfoValueObject,
      faqStructuredDataSeoMapper: SeoMappersFactory.faqStructuredDataSeoMapper({
        config
      }),
      fromRawFaqToFaqListValueObjectMapper: VehiclesMappersFactory.fromRawFaqToFaqListValueObjectMapper({
        config
      })
    })

  static fromSchemaDataToSchemaValueObjectMapper = ({config} = {}) =>
    new FromSchemaDataToSchemaValueObjectMapper({config})

  static seoMetaInformationMapper = ({config}) =>
    new SeoMetaInformationMapper({
      config,
      seoDataRequestErrorFactory: SeoErrorsFactory.seoDataRequestError,
      seoAdsListMetaInformationMapper: SeoMappersFactory.seoAdsListMetaInformationMapper({config}),
      seoAdsListSubscriptionMetaInformationMapper: SeoMappersFactory.seoAdsListSubscriptionMetaInformationMapper({
        config
      }),
      seoAdsDetailMetaInformationMapper: SeoMappersFactory.seoAdsDetailMetaInformationMapper({config}),
      seoDealersListMetaInformationMapper: SeoMappersFactory.seoDealersListMetaInformationMapper({config}),
      seoInstantOfferStandaloneMetaInformationMapper: SeoMappersFactory.seoInstantOfferStandaloneMetaInformationMapper({
        config
      }),
      seoInsuranceMetaInformationMapper: SeoMappersFactory.seoInsuranceMetaInformationMapper({config}),
      seoMakeMetaInformationMapper: SeoMappersFactory.seoMakeMetaInformationMapper({config}),
      seoMakesDistributorMetaInformationMapper: SeoMappersFactory.seoMakesDistributorMetaInformationMapper({config}),
      seoModelDetailMetaInformationMapper: SeoMappersFactory.seoModelDetailMetaInformationMapper({config}),
      seoModelSizesMetaInformationMapper: SeoModelSizesMetaInformationMapper.create({config}),
      seoNewsListMetaInformationMapper: SeoMappersFactory.seoNewsListMetaInformationMapper({config}),
      fromNewsDetailPageMetaInformationToSeoDataVOMapper:
        SeoMappersFactory.fromNewsDetailPageMetaInformationToSeoDataVOMapper({
          config
        }),
      seoProfessionalStockMetaInformationMapper: SeoMappersFactory.seoProfessionalStockMetaInformationMapper({config}),
      seoTechnicalDetailsMetaInformationMapper: SeoMappersFactory.seoTechnicalDetailsMetaInformationMapper({config}),
      seoTechnicalDetailsSearchMetaInformationMapper: SeoMappersFactory.seoTechnicalDetailsSearchMetaInformationMapper({
        config
      }),
      seoLandingFinancingMetaInformationMapper: SeoMappersFactory.seoLandingFinancingMetaInformationMapper({config}),
      seoLandingFormalitiesMetaInformationMapper: SeoMappersFactory.seoLandingFormalitiesMetaInformationMapper({
        config
      }),
      seoLandingFormalitiesSecurityGuidelinesMetaInformationMapper:
        SeoMappersFactory.seoLandingFormalitiesSecurityGuidelinesMetaInformationMapper({config}),
      seoLandingInstantOfferMetaInformationMapper: SeoMappersFactory.seoLandingInstantOfferMetaInformationMapper({
        config
      }),
      // web_seller_instant_offer_landing_test
      seoLandingInstantOfferTestMetaInformationMapper:
        SeoMappersFactory.seoLandingInstantOfferTestMetaInformationMapper({
          config
        }),
      seoEditMyAdMetaInformationMapper: SeoMappersFactory.seoEditMyAdMetaInformationMapper({config}),
      seoPublishMyAdMetaInformationMapper: SeoMappersFactory.seoPublishMyAdMetaInformationMapper({config}),
      seoPublishYourAdMetaInformationMapper: SeoMappersFactory.seoPublishYourAdMetaInformationMapper({config}),
      seoPublishMyAdCategoryMetaInformationMapper: SeoMappersFactory.seoPublishMyAdCategoryMetaInformationMapper({
        config
      }),
      seoPublishYourAdWithPlateMetaInformationMapper: SeoMappersFactory.seoPublishYourAdWithPlateMetaInformationMapper({
        config
      }),
      seoVehicleAppraiserMetaInformationMapper: SeoMappersFactory.seoVehicleAppraiserMetaInformationMapper({config}),
      seoHomeMetaInformationMapper: SeoMappersFactory.seoHomeMetaInformationMapper({config}),
      seoStaticMetaInformationMapper: SeoMappersFactory.seoStaticMetaInformationMapper({config})
    })

  static productStructuredDataSeoMapper = ({config}) =>
    new ProductStructuredDataSeoMapper({
      config,
      structuredDataValueObjectFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static seoAdsListMetaInformationMapper = ({config}) =>
    new SeoAdsListMetaInformationMapper({
      config,
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoAdsListSemanticMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticMetaConfigMapper({config}),
      vehicleStructuredDataSeoMapper: SeoMappersFactory.vehicleStructuredDataSeoMapper({config}),
      breadcrumbListStructuredDataSeoMapper: SeoMappersFactory.breadcrumbListStructuredDataSeoMapper({config}),
      webPageStructuredDataSeoMapper: SeoMappersFactory.webPageStructuredDataSeoMapper()
    })

  static seoAdsListSubscriptionMetaInformationMapper = ({config}) =>
    new SeoAdsListSubscriptionMetaInformationMapper({
      config,
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject,
      breadcrumbListStructuredDataSeoMapper: SeoMappersFactory.breadcrumbListStructuredDataSeoMapper({config}),
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      vehicleStructuredDataSeoMapper: SeoMappersFactory.vehicleStructuredDataSeoMapper({config}),
      webPageStructuredDataSeoMapper: SeoMappersFactory.webPageStructuredDataSeoMapper()
    })

  static seoAdsDetailMetaInformationMapper = ({config}) =>
    new SeoAdsDetailMetaInformationMapper({
      config,
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      vehicleTypeStructuredDataSeoMapper: SeoMappersFactory.vehicleTypeStructuredDataSeoMapper({
        config
      }),
      breadcrumbListStructuredDataSeoMapper: SeoMappersFactory.breadcrumbListStructuredDataSeoMapper({config})
    })

  static seoInstantOfferStandaloneMetaInformationMapper = ({config}) =>
    new SeoInstantOfferStandaloneMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoProfessionalStockMetaInformationMapper = ({config}) =>
    new SeoProfessionalStockMetaInformationMapper({
      config,
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      getSearchPaginationUrlAdsService: AdsServicesFactory.getSearchPaginationUrlAdsService({config}),
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject
    })

  static seoTechnicalDetailsMetaInformationMapper = ({config}) =>
    new SeoTechnicalDetailsMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoTechnicalDetailsSearchMetaInformationMapper = ({config}) =>
    new SeoTechnicalDetailsSearchMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      getUrlSearchService: SearchServicesFactory.getUrlSearchService({config}),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject,
      searchRequestValueObjectFactory: SearchValueObjectsFactory.searchRequestValueObject
    })

  static seoDealersListMetaInformationMapper = ({config}) =>
    new SeoDealersListMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoInsuranceMetaInformationMapper = ({config}) =>
    new SeoInsuranceMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoMakesDistributorMetaInformationMapper = ({config}) =>
    new SeoMakesDistributorMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoMakeMetaInformationMapper = ({config}) =>
    new SeoMakeMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoModelDetailMetaInformationMapper = ({config}) =>
    new SeoModelDetailMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject,
      productStructuredDataSeoMapper: SeoMappersFactory.productStructuredDataSeoMapper({config})
    })

  static seoNewsListMetaInformationMapper = ({config}) =>
    new SeoNewsListMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static fromNewsDetailPageMetaInformationToSeoDataVOMapper = ({config}) =>
    new FromNewsDetailPageMetaInformationToSeoDataVOMapper({
      config,
      fromArticleDataToStructuredDataVOSeoMapper: SeoMappersFactory.fromArticleDataToStructuredDataVOSeoMapper({
        config
      }),
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoLandingFinancingMetaInformationMapper = ({config}) =>
    new SeoLandingFinancingMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoLandingFormalitiesMetaInformationMapper = ({config}) =>
    new SeoLandingFormalitiesMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoLandingFormalitiesSecurityGuidelinesMetaInformationMapper = ({config}) =>
    new SeoLandingFormalitiesSecurityGuidelinesMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoLandingInstantOfferMetaInformationMapper = ({config}) =>
    new SeoLandingInstantOfferMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  // web_seller_instant_offer_landing_test
  static seoLandingInstantOfferTestMetaInformationMapper = ({config}) =>
    new SeoLandingInstantOfferTestMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoEditMyAdMetaInformationMapper = ({config}) =>
    new SeoEditMyAdMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoPublishMyAdMetaInformationMapper = ({config}) =>
    new SeoPublishMyAdMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoPublishYourAdMetaInformationMapper = ({config}) =>
    new SeoPublishYourAdMetaInformationMapper({
      config,
      structuredDataMapper: SeoMappersFactory.publishYourAdStructuredDataValueObjectSeoMapper({config}),
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoPublishMyAdCategoryMetaInformationMapper = ({config}) =>
    new SeoPublishMyAdCategoryMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoPublishYourAdWithPlateMetaInformationMapper = ({config}) =>
    new SeoPublishYourAdWithPlateMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoVehicleAppraiserMetaInformationMapper = ({config}) =>
    new SeoVehicleAppraiserMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static seoHomeMetaInformationMapper = ({config}) =>
    new SeoHomeMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject,
      structuredDataValueObjectFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static fromJsonToTagCloudSeoRequestSeoMapper = ({config}) =>
    new FromJsonToTagCloudSeoRequestSeoMapper({
      config,
      tagCloudSeoRequestFactory: SeoRequestsFactory.tagCloudSeoRequest
    })

  static fromTagCloudJsonResponseToTagCloudSeoValueObjectSeoMapper = ({config}) =>
    new FromTagCloudJsonResponseToTagCloudSeoValueObjectSeoMapper({
      config,
      tagcloudSeoValueObjectFactory: SeoValueObjectsFactory.tagcloudSeoValueObject({
        config
      }),
      tagcloudListValueObjectFactory: SeoValueObjectsFactory.tagcloudListValueObject
    })

  static seoLiteralMapper = () => new SeoLiteralMapper()

  static seoAdsListSemanticMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticMetaConfigMapper({
      config,
      seoAdsListSemanticPrivateSellerMetaConfigMapper:
        SeoMappersFactory.seoAdsListSemanticPrivateSellerMetaConfigMapper({
          config
        }),
      seoAdsListSemanticSevenSeatsMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticSevenSeatsMetaConfigMapper({
        config
      }),
      seoAdsListSemanticAutomaticMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticAutomaticMetaConfigMapper({
        config
      }),
      seoAdsListSemanticYearMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticYearMetaConfigMapper({config}),
      seoAdsListSemanticElectricMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticElectricMetaConfigMapper({
        config
      }),
      seoAdsListSemanticMaxPriceMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticMaxPriceMetaConfigMapper({
        config
      }),
      seoAdsListSemanticCampervanMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticCampervanMetaConfigMapper({
        config
      }),
      seoAdsListSemanticCarTrailerMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticCarTrailerMetaConfigMapper({
        config
      }),
      seoAdsListSemanticCheapVansMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticCheapVansMetaConfigMapper({
        config
      }),
      seoAdsListSemanticClassicCompetitionConfigMapper:
        SeoMappersFactory.seoAdsListSemanticClassicCompetitionConfigMapper({
          config
        }),
      seoAdsListSemanticTractorsMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticTractorsMetaConfigMapper({
        config
      }),
      seoAdsListSemanticTrucksConfigMapper: SeoMappersFactory.seoAdsListSemanticTrucksConfigMapper({
        config
      }),
      seoAdsListSemanticBusesConfigMapper: SeoMappersFactory.seoAdsListSemanticBusesConfigMapper({
        config
      }),
      seoAdsListSemanticFinancedMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticFinancedMetaConfigMapper({
        config
      }),
      seoAdsListSemanticColorMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticColorMetaConfigMapper({
        config
      }),
      seoAdsListSemanticVansMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticVansMetaConfigMapper({config}),
      seoAdsListSemanticCarsWithoutLicenseMetaConfigMapper:
        SeoMappersFactory.seoAdsListSemanticCarsWithoutLicenseMetaConfigMapper({
          config
        }),
      seoAdsListSemanticEnvironmentalLabelMetaConfigMapper:
        SeoMappersFactory.seoAdsListSemanticEnvironmentalLabelMetaConfigMapper({
          config
        }),
      seoAdsListSemanticLifestyleMetaConfigMapper: SeoMappersFactory.seoAdsListSemanticLifestyleMetaConfigMapper({
        config
      })
    })

  static seoAdsListSemanticPrivateSellerMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticPrivateSellerMetaConfigMapper({config})

  static seoAdsListSemanticSevenSeatsMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticSevenSeatsMetaConfigMapper({config})

  static seoAdsListSemanticAutomaticMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticAutomaticMetaConfigMapper({config})

  static seoAdsListSemanticYearMetaConfigMapper = ({config}) => new SeoAdsListSemanticYearMetaConfigMapper({config})

  static seoAdsListSemanticElectricMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticElectricMetaConfigMapper({config})

  static seoAdsListSemanticMaxPriceMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticMaxPriceMetaConfigMapper({config})

  static seoAdsListSemanticCampervanMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticCampervanMetaConfigMapper({config})

  static seoAdsListSemanticCarTrailerMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticCarTrailerMetaConfigMapper({config})

  static seoAdsListSemanticCheapVansMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticCheapVansMetaConfigMapper({config})

  static seoAdsListSemanticClassicCompetitionConfigMapper = ({config}) =>
    new SeoAdsListSemanticClassicCompetitionConfigMapper({config})

  static seoAdsListSemanticTrucksConfigMapper = ({config}) => new SeoAdsListSemanticTrucksMetaConfigMapper({config})

  static seoAdsListSemanticTractorsMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticTractorsMetaConfigMapper({config})

  static seoAdsListSemanticBusesConfigMapper = ({config}) => new SeoAdsListSemanticBusesMetaConfigMapper({config})

  static seoAdsListSemanticFinancedMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticFinancedMetaConfigMapper({config})

  static seoAdsListSemanticColorMetaConfigMapper = ({config}) => new SeoAdsListSemanticColorMetaConfigMapper({config})

  static vehicleStructuredDataSeoMapper = ({config}) =>
    new VehicleStructuredDataSeoMapper({
      config,
      structuredDataValueObjectFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static vehicleTypeStructuredDataSeoMapper = ({config}) =>
    new VehicleTypeStructuredDataSeoMapper({
      config,
      structuredDataValueObjectFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static webPageStructuredDataSeoMapper = () =>
    new WebPageStructuredDataSeoMapper({
      structuredDataValueObjectFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static seoStaticMetaInformationMapper = ({config}) =>
    new SeoStaticMetaInformationMapper({
      config,
      seoDataMapper: SeoMappersFactory.seoDataMapper({config}),
      seoLiteralMapper: SeoMappersFactory.seoLiteralMapper(),
      seoDataValueObjectFactory: SeoValueObjectsFactory.seoDataValueObject
    })

  static publishYourAdStructuredDataValueObjectSeoMapper = ({config}) =>
    new PublishYourAdStructuredDataValueObjectSeoMapper({
      config,
      structuredDataVOFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static fromArticleDataToStructuredDataVOSeoMapper = ({config}) =>
    new FromArticleDataToStructuredDataVOSeoMapper({
      config,
      structuredDataValueObjectFactory: SeoValueObjectsFactory.structuredDataValueObject
    })

  static seoAdsListSemanticVansMetaConfigMapper = ({config}) => new SeoAdsListSemanticVansMetaConfigMapper({config})

  static seoAdsListSemanticCarsWithoutLicenseMetaConfigMapper = ({config}) =>
    new SeoAdsListSemanticCarsWithoutLicenseMetaConfigMapper({config})

  static seoAdsListSemanticEnvironmentalLabelMetaConfigMapper = ({config}) =>
    SeoAdsListSemanticEnvironmentalLabelMetaConfigMapper.create({config})

  static seoAdsListSemanticLifestyleMetaConfigMapper = ({config}) =>
    SeoAdsListSemanticLifestyleMetaConfigMapper.create({config})
}
